function levenshtein(a: string, b: string): number {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const matrix = Array.from({ length: rows }, () =>
    Array.from({ length: cols }, () => 0)
  );

  for (let i = 0; i < rows; i += 1) matrix[i]![0] = i;
  for (let j = 0; j < cols; j += 1) matrix[0]![j] = j;

  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      matrix[i]![j] = Math.min(
        matrix[i - 1]![j]! + 1,
        matrix[i]![j - 1]! + 1,
        matrix[i - 1]![j - 1]! + cost
      );
    }
  }

  return matrix[a.length]![b.length]!;
}

function getSearchableWords(...fields: string[]): string[] {
  return fields
    .join(' ')
    .toLowerCase()
    .split(/[^a-z0-9]+/i)
    .filter(Boolean);
}

function tokenMatchesWord(token: string, word: string): boolean {
  if (word.includes(token)) return true;
  if (token.length >= 2 && word.startsWith(token)) return true;

  if (token.length >= 3 && word.length >= 3) {
    const maxDistance = token.length <= 4 ? 1 : 2;
    return levenshtein(word, token) <= maxDistance;
  }

  return false;
}

/** Returns true when query is empty or fuzzily matches any provided field. */
export function fuzzyMatchesSearch(
  query: string,
  ...fields: string[]
): boolean {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return true;
  if (normalizedQuery.length < 2) return true;

  const haystack = fields.join(' ').toLowerCase();
  if (haystack.includes(normalizedQuery)) return true;

  const words = getSearchableWords(...fields);
  const tokens = normalizedQuery
    .split(/\s+/)
    .filter((token) => token.length >= 2);

  if (tokens.length === 0) {
    return haystack.includes(normalizedQuery);
  }

  return tokens.every((token) =>
    words.some((word) => tokenMatchesWord(token, word))
  );
}
